import React from 'react';

/** Explicit 404 for retired public routes (e.g. the old /store/{slug} storefront, now served by Website Builder store blocks). */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-6" data-testid="not-found-page">
      <img src="/pillot-icon.png" alt="" className="h-12 w-12 mb-4 opacity-70" />
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">404</div>
      <h1 className="mt-2 text-2xl font-semibold text-slate-900">Halaman tidak ditemukan</h1>
      <p className="mt-2 max-w-md text-sm text-slate-500">Alamat ini sudah tidak tersedia. Toko online kini menjadi bagian dari website tenant — buka website resmi toko untuk berbelanja. / This page is no longer available.</p>
    </div>
  );
}
